import script from "./AnimatableText.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimatableText.vue?vue&type=script&setup=true&lang=js"

import "./AnimatableText.vue?vue&type=style&index=0&id=47a1a85e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47a1a85e"]])

export default __exports__